// @ts-nocheck
import React from 'react';

import { ColumnOptions } from '../ColumnOptions';
import FiltersSettings from '../ReportDownloadForm/FilterSettings/FiltersSettings';
import { useReportDownloadSectionContext } from '../ReportDownloadSection.context';
import { DocumentSettingsStyle } from './documentSettings.styles';

type Props = {
  id: string;
  tabId: string;
};

function DocumentSettings({ id, tabId }: Props) {
  const { getOtherOptions, getTabOptions, setColumnsOptions, setOtherOptions } = useReportDownloadSectionContext();
  const stats = getTabOptions(tabId).columns;
  const otherOptions = getOtherOptions(tabId);

  return (
    <DocumentSettingsStyle className="documentSettings" id={id}>
      <div className="documentSettings__container">
        <div className="documentSettings__containerColumns">
          <FiltersSettings tabId={tabId} />
          <ColumnOptions
            id={`ColumnOptions-${id}`}
            isAddressToLocations={otherOptions.addressInfo}
            isCoordinatesToLocations={otherOptions.coordinatesInfo}
            onAddressToLocations={val =>
              setOtherOptions(tabId, {
                ...otherOptions,
                addressInfo: val
              })
            }
            onColumnsSelectedChange={val => setColumnsOptions(tabId, val)}
            onCoordinatesToLocations={val =>
              setOtherOptions(tabId, {
                ...otherOptions,
                coordinatesInfo: val
              })
            }
            stats={stats}
          />
        </div>
      </div>
    </DocumentSettingsStyle>
  );
}

export default DocumentSettings;
